<div class="Footer_bottom">
  <section>
    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <svg class="me-2 pointer" (click)="backToForm()" id="keyboard_backspace_black_24dp_3_"
          data-name="keyboard_backspace_black_24dp(3)" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
          viewBox="0 0 24 24">
          <path id="Path_7892" data-name="Path 7892" d="M0,0H24V24H0Z" fill="none" />
          <path id="Path_7893" data-name="Path 7893" d="M21,11H6.83l3.58-3.59L9,6,3,12l6,6,1.41-1.41L6.83,13H21Z"
            fill="black" />
        </svg>

        <nav aria-label="breadcrumb" class="my-3">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item fs-18 fw-400 pointer" (click)="backToIpsa()">PRISM</li>
            <li class="breadcrumb-item fs-18 fw-400 pointer" (click)="backToForm()">PRISM V1.0 Forms</li>
            <li class="breadcrumb-item fs-18 fw-600 pointer active-breadcrumb active">{{showFormName}}</li>
          </ol>
        </nav>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="d-md-flex justify-content-end mb-3">
            <div class="d-flex align-items-center">
              <img src="../../../assets/images/download-form.svg" class="img-fluid pointer me-4 d-none" alt=""
                [matTooltip]="'Download CSV'" (click)="downloadCSV()">
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="card border-0 mb-3">
          <div class="card-body">
            <div class="mb-3 align-items-center">
              <button class="btn rounded-pill text-white" style="background-color: #00625F;"
                (click)="viewFormStructure(formListData[0]?._id)" *ngIf="showAddNewForm && userData?.userlevel_id != 1">
                + Add New Form
              </button>
              <mat-paginator class="f-14" [length]="totalDataCount" [pageSize]="limit" [pageIndex]="page"
                aria-label="Select page" (page)="setPage($event)" showFirstLastButtons *ngIf="totalDataCount !== 0">
              </mat-paginator>
              <div class="position-relative" style="display: none">
                <img src="../../../assets/images/search-line.svg" class="img-fluid position-absolute search-icon"
                  alt="">
                <input type="search" placeholder="Search by" class="form-control search-input">
              </div>

            </div>

            <div class="table-responsive" *ngIf="formListingData.length > 0">
              <table class="table table-borderless">
                <thead class="table-light">
                  <tr>
                    <th>S.No.</th>
                    <th>Sector</th>
                    <th>MSME</th>
                    <th>Status</th>
                    <th>Action</th>
                    <th>Improvement Plan</th>
                  </tr>
                </thead>
                <tbody class="bg-white">
                  <tr *ngFor="let item of formListingData | slice:skip:skip + limit; let i = index">
                    <td>{{i + skip + 1}}</td>
                    <td>{{item.sectorName}}</td>
                    <td>{{item.msmeName}}</td>
                    <td>
                      <div class="formStatus" [ngStyle]="{'background-color': item?.isDraft ? '#ffa700d9' : '#47d985'}">
                        <span class="status">{{item?.isDraft ? "Draft" : "Submitted"}}</span>
                      </div>
                    </td>
                    <td>
                      <i class="img-fluid me-2 pointer fa fa-eye fas" alt="" (click)="editForm('viewMode',item)"
                        matTooltip="View Data"></i>
                      <img *ngIf="userData?.userlevel_id != 1" src="../../../assets/images/edit.svg"
                        class="img-fluid me-2 pointer" alt="" (click)="editForm('editMode',item)"
                        matTooltip="Edit Data">
                    </td>
                    <td>
                      <button *ngIf="userData?.userlevel_id != 1 || userData?.userlevel_id == 1 && item.submissionId"
                        class="btn btn-sm rounded-pill text-white" style="background-color: #00625F;"
                        (click)="openImprovementPlan(item)">
                        Open
                      </button>
                      <span *ngIf="userData?.userlevel_id == 1 && !item.submissionId">Not Filled</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="noDataFound" class="d-flex justify-content-center">
              <img alt="no data" src="../../../../assets/no_data_image/error-logo.png" class="noDataImage">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>